<template>
    <div>
        <el-form :model="formInfo" :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <div class="content-caption dashed">
                <span>拆分单信息</span>
            </div>
            <div class="simple-form flex col-3">
                <div class="form-group">
                    <div class="form-label">
                        <label class="required">机构信息</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="retailerComFullName" :rules="{validator : checkRetailerCom, trigger: 'change'}">
                            <el-input class="width-1-5x" v-model="formInfo.retailerComFullName" :disabled="true"></el-input>
                            <span class="swb-btn swb-btn-link" @click="selectCom">选择</span>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label class="required">标题</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="title">
                            <el-input class="width-2x" v-model="formInfo.title"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label class="required">拆分原因</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="splitDesc">
                            <el-input class="width-2x" type="textarea" :rows="2" placeholder="请输入拆分原因" v-model="formInfo.splitDesc"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group" v-if="formInfo.id != null && formInfo.id > 0">
                    <div class="form-label">
                        <label>拆分单号</label>
                    </div>
                    <div class="form-value">
                        <span>{{formInfo.innerNo || '无'}}</span>
                    </div>
                </div>
            </div>
            <div class="content-caption dashed">
                <span>资产信息</span>
                <a class="swb-btn swb-btn-link" @click="selectAsset()">通用选择</a>
            </div>
            <div class="simple-form flex col-4">
                <div class="form-group">
                    <div class="form-label">
                        <label class="required">资产编号</label>
                    </div>
                    <div class="form-value">
                        <span>{{formInfo.devcInnerCode || ''}}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>系统编号</label>
                    </div>
                    <div class="form-value">
                        <span>{{formInfo.devcNo || ''}}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>资产描述全称</label>
                    </div>
                    <div class="form-value">
                        <span>{{formInfo.devcTitle || ''}}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>管理方式</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetTypeMap[formInfo.assetType]}}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>控制方式</label>
                    </div>
                    <div class="form-value">
                        <span v-if="formInfo.devcInnerCode != null">{{formInfo.splitible ? '按金额' : '按数量'}}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>资产原值(元)</label>
                    </div>
                    <div class="form-value">
                        <span>{{(formInfo.orgWorth || 0).toFixed(2)}}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>拆分原值(元)</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="splitAmount">
                            <el-input class="width-1x" v-model="formInfo.splitAmount" @change="splitAmountChange"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>剩余可拆分原值(元)</label>
                    </div>
                    <div class="form-value">
                        <span>{{(formInfo.splitableAmount || 0).toFixed(2)}}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>资产数量</label>
                    </div>
                    <div class="form-value">
                        <span>{{formInfo.theQuantity}}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>拆分数量</label>
                    </div>
                    <div class="form-value">
                        <span>{{formInfo.theQuantity}}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>剩余可拆分数量</label>
                    </div>
                    <div class="form-value">
                        <span>{{formInfo.theQuantity}}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label></label>
                    </div>
                    <div class="form-value">
                        <span><a class="swb-btn swb-btn-small" @click="doSplit(null, null)">确认拆分</a></span>
                    </div>
                </div>
            </div>
            <div class="content-caption dashed">
                <span class="required">新资产信息</span>
            </div>
            <div class="table-layout">
                <el-table :data="formInfo.itemList" border maxHeight="400" ref="dataTable" tooltip-effect="dark" :summary-method="getItemAmountSum" show-summary style="width: 100%">
                    <el-table-column align="left" prop="devcInnerCode" label="资产编号" width="160" fixed show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="title" label="资产描述全称" width="200" fixed show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="modelSpec" label="型号规格" width="120" show-overflow-tooltip></el-table-column>
                    <el-table-column align="right" prop="theQuantity" label="数量" width="100" show-overflow-tooltip></el-table-column>
                    <el-table-column align="right" prop="orgWorth" label="原值(元)" width="150" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <el-form-item :prop="'itemList.' + rows.$index + '.orgWorth'" :rules="{validator: inputOrgWorth, trigger: 'change'}">
                                <el-input type="text" v-model="rows.row.orgWorth" @change="orgWorthChange(rows.row, rows.$index)"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="aggtDeprWorth" label="累计折旧(元)" width="150" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <span v-if="rows.row.aggtDeprWorth != null">{{rows.row.aggtDeprWorth.toFixed(2)}}</span>
                            <span v-else>0.00</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="netWorth" label="净值(元)" width="150" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <span v-if="rows.row.netWorth != null">{{rows.row.netWorth.toFixed(2)}}</span>
                            <span v-else>0.00</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" prop="retailerComFullName" label="所属部门" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" prop="" width="60" label="操作">
                        <template slot-scope="rows">
                            <a class="swb-btn-link" @click="removeItem(rows.$index)">移除</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-form>
    </div>
</template>

<script>
import { Utils } from '../../app.base'
import { MsgBox, Vue } from '../../app.vues'
import { showDevcSelectDlg } from '../devc/selectDlg'
import { isSysRescFrozenIsAllowed } from '../index'

import devcApi from '../../api/devc'
import shopDevcApi from '../../api/shopDevc'

export default {
    name: 'swb-devc-split-form-save',
    desc: '拆分单保存',
    props: ["id", "comId", "comFullName"],
    data: function () {
        let validateTitle = function (rule, value, callback) {
            if (Utils.isNoB(value)) {
                callback(new Error('标题不可为空'));
            } else {
                if (value.length > 60) {
                    callback(new Error('标题最大长度不可超过60'));
                } else {
                    callback();
                }
            }
        };
        let validateSplitDesc = function (rule, value, callback) {
            if (Utils.isNoB(value)) {
                callback(new Error('拆分原因不可为空'));
            } else {
                if (value.length > 250) {
                    callback(new Error('拆分原因最大长度不可超过250'));
                } else {
                    callback();
                }
            }
        };
        return {
            formInfo: {},
            dbFormInfo: {},
            assetTypeMap: getEnumMap('assetType', 'value2text'),
            // 校验
            rules: {
                title: [{validator: validateTitle, trigger: 'blur'}],
                splitDesc: [{validator: validateSplitDesc, trigger: 'blur'}],
            }
        }
    },
    created: function () {
        if (!Utils.isNoB(this.id)) {
            this.getformInfoDetail();
        } else {
            if (!Utils.isNoB(this.comId)) {
                let comInfo = {};
                comInfo.id = this.comId;
                let isAllowed = isSysRescFrozenIsAllowed(this, comInfo);
                if(isAllowed) {
                    let formInfo = this.formInfo || {};
                    formInfo.retailerComId = this.comId;
                    formInfo.retailerComFullName = this.comFullName;
                    this.formInfo = Utils.merge({}, formInfo);
                }
            }
        }
    },
    methods: {
        // 查看拆分单详情
        getformInfoDetail: function () {
            let self = this;
            //
            let params = {};
            params.id = self.id;
            let msgBoxDlg = MsgBox.loading();
            devcApi.getDevcSplitFormDetail(params, function (result) {
                msgBoxDlg.close();
                if (result.type == 'info') {
                    let formInfo = result.data || {};
                    let itemList = formInfo.itemList || [];
                    // 计算已拆分金额、可拆分金额
                    let splitedAmountX = 0;
                    for (let i = 0, len = itemList.length; i < len; i++) {
                        let item = itemList[i];
                        splitedAmountX = splitedAmountX + parseFloat(item.orgWorth || 0);
                    }
                    formInfo.splitableAmount = parseFloat(formInfo.orgWorth || 0) - splitedAmountX;
                    self.formInfo = Utils.merge({}, formInfo);
                    self.dbFormInfo = Utils.merge({}, formInfo);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 校验机构信息
        checkRetailerCom: function (rule, value, callback) {
            if (Utils.isNoB(value)) {
                callback(new Error('请选择机构信息'));
            } else {
                callback();
            }
        },
        // 原值校验
        inputOrgWorth: function (rule, value, callback) {
            if (Utils.isNoB(value)) {
                callback(new Error('请输入原值'));
            } else {
                if (!Utils.isMoneyStr(value) || parseFloat(value) <= 0) {
                    callback(new Error('请输入大于0的金额'));
                } else {
                    callback();
                }
            }
        },
        // 选择机构
        selectCom: function () {
            // 机构信息发生变化，清空新资产信息
            let self = this;
            Vue.$showDialog({
                title: '零售商机构-选择',
                width: 750,
                height: 600,
                showCloseBtn: true,
                template: '<swb-org-tree :isShowIcon="false" :isSelectThisLevel="isSelectThisLevel" :isRadio="isRadio" :isCom="isCom" :bizDepart="true" :optionalState="[1,3]" ref="swb_org_tree"></swb-org-tree>',
                data: {
                    isRadio: true,
                    isCom: false,
                    isSelectThisLevel: true
                },
                okClicked: function () {
                    let result = this.$refs.swb_org_tree.getDlgResult() || {};
                    if (result.type == "info") {
                        let shopRetail = result.data || {};
                        //
                        let formInfo = self.formInfo || {};
                        if (formInfo.retailerComId != shopRetail.id) {
                            formInfo.itemList = [];
                            formInfo.devcId = null;
                            formInfo.devcInnerCode = null;
                            formInfo.devcNo = null;
                            formInfo.devcTitle = null;
                            formInfo.assetType = null;
                            formInfo.modelSpec = null;
                            formInfo.splitible = null;
                            formInfo.orgWorth = null;
                            formInfo.netWorth = null;
                            formInfo.aggtDeprWorth = null;
                            formInfo.theQuantity = null;
                            formInfo.splitableAmount = null;
                        }
                        formInfo.retailerComId = shopRetail.id;
                        formInfo.retailerComFullName = shopRetail.fullName;
                        //
                        self.formInfo = Utils.merge({}, formInfo);
                    } else {
                        return false;
                    }
                }
            });
        },
        // 选择资产
        selectAsset: function () {
            let self = this;
            let formInfo = self.formInfo || {};
            if (Utils.isNoB(formInfo.retailerComId)) {
                MsgBox.warning("请选择机构！");
                return;
            }
            //
            let deviceIds = [];
            if (!Utils.isNoB(formInfo.devcId)) {
                deviceIds.push(formInfo.devcId);
            }
            //
            let filter = {};
            filter.retailerComId = formInfo.retailerComId;
            filter.splitible = true;
            filter.locked = false;
            filter.fiscalLocked = false;
            filter.cleared = false;
            filter.fiscalAbnormal = false;
            //
            showDevcSelectDlg({
                    filter: filter,
                    initSelectIds: deviceIds,
                    checkBox: false
                }, function (deviceInfo) {
                    if (formInfo.devcId != deviceInfo.id) {
                        formInfo.itemList = [];
                        formInfo.splitableAmount = deviceInfo.orgWorth;
                    }
                    formInfo.devcId = deviceInfo.id;
                    formInfo.devcInnerCode = deviceInfo.innerCode;
                    formInfo.devcNo = deviceInfo.tmpNo;
                    formInfo.devcTitle = deviceInfo.title;
                    formInfo.assetType = deviceInfo.assetType;
                    formInfo.modelSpec = deviceInfo.modelSpec;
                    formInfo.splitible = deviceInfo.splitible;
                    formInfo.orgWorth = deviceInfo.orgWorth;
                    formInfo.netWorth = deviceInfo.netWorth;
                    formInfo.aggtDeprWorth = deviceInfo.aggtDeprWorth;
                    formInfo.theQuantity = deviceInfo.existQuanity;
                    formInfo.retailerComFullName = deviceInfo.retailerComFullName;
                    //
                    self.formInfo = Utils.merge({}, formInfo);
                }
            );
        },
        // 拆分金额变化事件
        splitAmountChange: function () {
            // 拆分金额发生变化，不自动计算可拆分金额，确认拆分的时候再计算可拆分金额
            let formInfo = this.formInfo || {};
            let splitAmount = formInfo.splitAmount;
            let splitableAmount = parseFloat(formInfo.splitableAmount || 0);
            let errMsg = '';
            if (Utils.isNoB(splitAmount) || !Utils.isMoneyStr(splitAmount) || parseFloat(splitAmount) <= 0) {
                errMsg = '请输入大于0的拆分金额！';
            } else if (parseFloat(splitAmount) > splitableAmount) {
                errMsg = '输入的拆分金额超过了可拆分金额，请重新输入！';
            }
            if (!Utils.isNoB(errMsg)) {
                MsgBox.warning(errMsg);
                formInfo.splitAmount = null;
                this.formInfo = Utils.merge({}, formInfo);
            } else {
                formInfo.splitAmount = parseFloat(splitAmount || 0).toFixed(2);
                this.formInfo = Utils.merge({}, formInfo);
            }
            return errMsg;
        },
        // 确认拆分, item与index一起穿才有效
        doSplit: function (item, index) {
            let self = this;
            // 校验拆分金额
            let formInfo = this.formInfo || {};
            let itemList = formInfo.itemList || [];
            if (Utils.isNoB(formInfo.devcId) || formInfo.devcId <= 0) {
                MsgBox.warning("请选择要拆分的资产！");
                return;
            }
            //
            if (Utils.isNoB(item) || Utils.isNoB(index)) {
                let errMsg = self.splitAmountChange();
                if (!Utils.isNoB(errMsg)) {
                    return;
                }
            }
            // 计算已拆分金额
            let splitedAmount = 0;
            let splitedAggtDeprWorth = 0;
            for (let i = 0, len = itemList.length; i < len; i++) {
                let item = itemList[i];
                if (!Utils.isNoB(item) && !Utils.isNoB(index)) {
                    if (i != index) {
                        splitedAmount = splitedAmount + parseFloat(item.orgWorth || 0);
                        splitedAggtDeprWorth = splitedAggtDeprWorth + parseFloat(item.aggtDeprWorth || 0);
                    }
                } else {
                    splitedAmount = splitedAmount + parseFloat(item.orgWorth || 0);
                    splitedAggtDeprWorth = splitedAggtDeprWorth + parseFloat(item.aggtDeprWorth || 0);
                }
            }
            // 调用后台根据拆分金额计算净值、累计折旧
            let postData = {};
            postData.splitedAmount = splitedAmount;
            postData.splitedAggtDeprWorth = splitedAggtDeprWorth;
            postData.srcOrgWorth = formInfo.orgWorth;
            postData.srcAggtDeprWorth = formInfo.aggtDeprWorth;
            if (!Utils.isNoB(item) && !Utils.isNoB(index)) {
                let orgWorth = item.orgWorth;
                if (Utils.isNoB(orgWorth) || !Utils.isMoneyStr(orgWorth) || parseFloat(orgWorth || 0) <= 0) {
                    MsgBox.warning("新资产中原值必须大于0！");
                    return;
                }
                //
                postData.dstOrgWorth = orgWorth;
            } else {
                postData.dstOrgWorth = parseFloat(formInfo.splitAmount || 0);
            }
            let msgBoxDlg = MsgBox.loading();
            shopDevcApi.getCalAssetWorth(postData, function (result) {
                msgBoxDlg.close();
                if (result.type == 'info') {
                    let worthInfo = result.data || {};
                    if (!Utils.isNoB(item) && !Utils.isNoB(index)) {
                        itemList[index].orgWorth = worthInfo.dstOrgWorth;
                        itemList[index].aggtDeprWorth = worthInfo.dstAggtDeprWorth;
                        itemList[index].netWorth = worthInfo.dstNetWorth;
                    } else {
                        // 新增一条
                        let itemInfo = {};
                        itemInfo.title = formInfo.devcTitle;
                        itemInfo.modelSpec = formInfo.modelSpec;
                        itemInfo.theQuantity = formInfo.theQuantity;
                        itemInfo.orgWorth = worthInfo.dstOrgWorth;
                        itemInfo.aggtDeprWorth = worthInfo.dstAggtDeprWorth;
                        itemInfo.netWorth = worthInfo.dstNetWorth;
                        itemInfo.retailerComFullName = formInfo.retailerComFullName;
                        itemList.push(itemInfo);
                    }
                    // 计算已拆分金额、可拆分金额
                    let splitedAmountX = 0;
                    for (let i = 0, len = itemList.length; i < len; i++) {
                        let item = itemList[i];
                        splitedAmountX = splitedAmountX + parseFloat(item.orgWorth || 0);
                    }
                    formInfo.splitableAmount = parseFloat(formInfo.orgWorth || 0) - splitedAmountX;
                    //
                    formInfo.itemList = Utils.merge([], itemList);
                    self.formInfo = Utils.merge({}, formInfo);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 原值变化，重新计算净值累计折旧
        orgWorthChange: function (row, index) {
            let formInfo = this.formInfo || {};
            let itemList = formInfo.itemList || [];
            let splitAmount = 0;
            for (let i = 0, len = itemList.length; i < len; i++) {
                if (i != index) {
                    let item = itemList[i];
                    splitAmount = splitAmount + parseFloat(item.orgWorth || 0);
                }
            }
            // 可拆分金额
            let splitableAmount = parseFloat(formInfo.orgWorth || 0) - splitAmount;
            if (splitableAmount < 0) {
                splitableAmount = 0;
            }
            if (!Utils.isNoB(row.orgWorth)) {
                if (parseFloat(row.orgWorth) > splitableAmount) {
                    MsgBox.warning("该金额超过了可拆分金额，请重新输入！");
                    row.orgWorth = null;
                } else {
                    row.orgWorth = parseFloat(row.orgWorth || 0).toFixed(2);
                }
            }
            if (Utils.isNoB(row.orgWorth)) {
                row.netWorth = null;
                row.aggtDeprWorth = null;
            } else {
                // 重新计算净值、累计折旧
                this.doSplit(row, index);
                //
                splitableAmount = splitableAmount - parseFloat(row.orgWorth);
            }
            formInfo.splitableAmount = splitableAmount;
            this.formInfo = Utils.merge({}, formInfo);
        },
        // 移除
        removeItem: function (index) {
            let formInfo = this.formInfo || {};
            let itemList = formInfo.itemList || [];
            for (let i = 0, len = itemList.length; i < len; i++) {
                if (i == index) {
                    itemList.splice(i, 1);
                    break;
                }
            }
            // 计算已拆分金额、可拆分金额
            let splitedAmountX = 0;
            for (let i = 0, len = itemList.length; i < len; i++) {
                let item = itemList[i];
                splitedAmountX = splitedAmountX + parseFloat(item.orgWorth || 0);
            }
            formInfo.splitableAmount = parseFloat(formInfo.orgWorth || 0) - splitedAmountX;
            formInfo.itemList = Utils.merge([], itemList);
            this.formInfo = Utils.merge({}, formInfo);
        },
        //
        getItemAmountSum: function (param) {
            const {columns, data} = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                let flag = true;
                let quantityFlag = false;
                let values = data.map(item => Number(item[column.property]));
                //
                if (column.property == 'quantity') {
                    values = data.map(item => Number(item['quantity']));
                    quantityFlag = true;
                } else if (column.property == 'orgWorth') {
                    values = data.map(item => Number(item['orgWorth']));
                } else if (column.property == 'netWorth') {
                    values = data.map(item => Number(item["netWorth"]));
                } else if (column.property == 'aggtDeprWorth') {
                    values = data.map(item => Number(item["aggtDeprWorth"]));
                } else {
                    flag = false;
                }
                if (flag && !values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (quantityFlag) {
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        } else {
                            if (!isNaN(value)) {
                                return (parseFloat(prev) + parseFloat(curr)).toFixed(2);
                            } else {
                                return parseFloat(prev).toFixed(2);
                            }
                        }
                    }, 0);
                    if (quantityFlag) {
                        sums[index];
                    } else {
                        sums[index] += ' 元';
                    }
                } else {
                    sums[index] = '-';
                }
            });
            return sums;
        },
        // 返回结果
        getDlgResult: function () {
            let self = this;
            let result = {};
            this.$refs['ruleForm'].validate(function (valid) {
                if (valid) {
                    let formInfo = self.formInfo || {};
                    if (Utils.isNoB(formInfo.devcId) || formInfo.devcId <= 0) {
                        result.message = "请选择要拆分的资产！";
                        result.type = "warn";
                    } else {
                        let itemList = formInfo.itemList || [];
                        if (itemList.length <= 0) {
                            result.message = "请设置拆分条目！";
                            result.type = "warn";
                        } else {
                            result.data = formInfo;
                            result.type = "info";
                        }
                    }
                } else {
                    result.type = 'warn';
                    result.message = '校验失败';
                }
            });

            return result;
        },
        getFormInfo: function () {
            let result = {};
            result.dbFormInfo = this.dbFormInfo || {};
            result.formInfo = this.formInfo || {};
            return result;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/devcSplit/DevcSplitFormSave.vue